import React, {useContext} from 'react';

import InlineInputControlRow from '../../../../ui/layout/InlineInputControlRow';
import TextBox from '../../../../ui/TextBox';
import DateTime from '../../../../ui/DateTime';
import Date from '../../../../ui/Date';
import {HblStatusViewModel} from '../../../../fms.core/HblStatusViewModel';
import InlineInputControlRowNoLabel from '../../../../ui/layout/InlineInputControlRowNoLabel';
import BlueTitleRow from '../../../../ui/BlueTitleRow';
import BlStatusRow from '../../../common/BlStatusRow';
import ApplicationContext from '../../../../ApplicationContext';
import { now } from '../../../../dateUtils';

function HawbMilestone({
  blStatus,
  onChange,
  isView
}: {
  blStatus: HblStatusViewModel,
  onChange: (x: Partial<HblStatusViewModel>) => void,
  isView: boolean,
}) {
  const appContext = useContext(ApplicationContext);
  const user = appContext.user?.id??'';

  return (
    <div>
      <div style={{display: 'flex'}}>
        <div style={{marginLeft: '30px', width: '295px'}}>
          <InlineInputControlRow label="HAWB #" bold mode="smaller-2x">
            <div style={{width: '100px'}}>
              <TextBox value={blStatus.hblNo} disabled />
            </div>
          </InlineInputControlRow>

          <InlineInputControlRow label="Departure Airport" mode="smaller-2x">
            <TextBox value={blStatus.lCode} disabled />
          </InlineInputControlRow>

          <InlineInputControlRow label="Final Destination" mode="smaller-2x">
            <TextBox value={blStatus.finalDest} disabled />
          </InlineInputControlRow>

          <InlineInputControlRow label="Carrier" mode="smaller-2x">
            <TextBox value={blStatus.carrierName} disabled />
          </InlineInputControlRow>

          <InlineInputControlRow label="Final Warehouse" mode="smaller-2x">
            <TextBox value={blStatus.cfsLocationName} disabled />
          </InlineInputControlRow>
        </div>

        <div style={{marginLeft: '30px', width: '325px'}}>
          <InlineInputControlRowNoLabel>
            &nbsp;
          </InlineInputControlRowNoLabel>

          <InlineInputControlRow label="ETD" mode="w60">
            <div style={{width: '130px'}}>
              <DateTime disabled value={blStatus.etd} />
            </div>
          </InlineInputControlRow>

          <InlineInputControlRow label="ETA" mode="w60">
            <div style={{width: '130px'}}>
              <DateTime disabled value={blStatus.eta} />
            </div>
          </InlineInputControlRow>

          <InlineInputControlRow label="F. ETA" mode="w60">
            <div style={{width: '130px'}}>
              <DateTime disabled value={blStatus.fEta} />
            </div>
          </InlineInputControlRow>
        </div>
      </div>
      <div style={{display: 'flex'}}>
        <div style={{width: '325px'}}>
          <div style={{marginLeft: '30px'}}>
            <InlineInputControlRow label="Storage Start Date" mode="smaller-2x">
              <div style={{width: '80px'}}>
                <Date disabled value={blStatus.storageDate} />
              </div>
            </InlineInputControlRow>

            <InlineInputControlRow label="G.O Date" mode="smaller-2x">
              <div style={{width: '80px'}}>
                <Date disabled value={blStatus.goDate} />
              </div>
            </InlineInputControlRow>
          </div>
        </div>
        <div style={{marginLeft: '30px', width: '325px'}}>
          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="OP Close"
              disabled
              checked={blStatus.opClosed}
              onToggle={() => {}}
              dateTime={blStatus.opCloseDate}
              onDateTimeChange={() => {}}
              userId={blStatus.opClosedBy}
              showDatePlaceHolder={false}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Period Close"
              disabled
              checked={blStatus.actClosed}
              onToggle={() => {}}
              dateTime={blStatus.actClosed ? blStatus.actCloseDate : ''}
              onDateTimeChange={() => {}}
              userId={blStatus.actClosed ? blStatus.actClosedBy : ''}
              showDatePlaceHolder={false}
            />
          </InlineInputControlRowNoLabel>
        </div>
      </div>

      <div style={{marginTop: '10px'}}>
        <BlueTitleRow title={<span style={{paddingLeft: '14px'}}>B/L Status</span>} />
      </div>

      <div style={{display: 'flex'}}>
        <div style={{width: '325px'}}>
          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Tracker"
              disabled={isView}
              checked={!!blStatus.f7501Chk}
              onToggle={f7501Chk => onChange({
                f7501Chk,
                f7501Date: f7501Chk ? now() : null,
                f7501By: f7501Chk ? user : '',
                })}
              dateTime={blStatus.f7501Date}
              onDateTimeChange={f7501Date => onChange({f7501Date, f7501By: f7501Date ? blStatus.f7501By : '', f7501Chk: f7501Date ? blStatus.f7501Chk : false})}
              userId={blStatus.f7501By}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Last Tracked"
              disabled={isView}
              checked={!!blStatus.puSentChk}
              onToggle={puSentChk => onChange({
                puSentChk,
                puSentDate: puSentChk ? now() : null,
                puSentBy: puSentChk ? user : '',
                })}
              dateTime={blStatus.puSentDate}
              onDateTimeChange={puSentDate => onChange({puSentDate, puSentBy: puSentDate ? blStatus.puSentBy : '', puSentChk: puSentDate ? blStatus.puSentChk : false})}
              userId={blStatus.puSentBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Send Arrival Notice"
              disabled={isView}
              checked={!!blStatus.anSentChk}
              onToggle={anSentChk => onChange({
                anSentChk,
                anSentDate: anSentChk ? now() : null,
                anSentBy: anSentChk ? user : '',
                })}
              dateTime={blStatus.anSentDate}
              onDateTimeChange={anSentDate => onChange({anSentDate, anSentBy: anSentDate ? blStatus.anSentBy : '', anSentChk: anSentDate ? blStatus.anSentChk : false})}
              userId={blStatus.anSentBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Receive HAWB"
              disabled={isView}
              checked={!!blStatus.trackerChk}
              onToggle={trackerChk => onChange({
                trackerChk,
                trackerDate: trackerChk ? now() : null,
                trackerBy: trackerChk ? user : '',
                })}
              dateTime={blStatus.trackerDate}
              onDateTimeChange={trackerDate => onChange({trackerDate, trackerBy: trackerDate ? blStatus.trackerBy : '', trackerChk: trackerDate ? blStatus.trackerChk : false})}
              userId={blStatus.trackerBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Receive Packing List"
              disabled={isView}
              checked={!!blStatus.lastTrackChk}
              onToggle={lastTrackChk => onChange({
                lastTrackChk,
                lastTrackDate: lastTrackChk ? now() : null,
                lastTrackBy: lastTrackChk ? user : '',
                })}
              dateTime={blStatus.lastTrackDate}
              onDateTimeChange={lastTrackDate => onChange({lastTrackDate, lastTrackBy: lastTrackDate ? blStatus.lastTrackBy : '', lastTrackChk: lastTrackDate ? blStatus.lastTrackChk : false})}
              userId={blStatus.lastTrackBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Receive Comm. Docs"
              disabled={isView}
              checked={!!blStatus.commDocChk}
              onToggle={commDocChk => onChange({
                commDocChk,
                commDocDate: commDocChk ? now() : null,
                commDocBy: commDocChk ? user : '',
                })}
              dateTime={blStatus.commDocDate}
              onDateTimeChange={commDocDate => onChange({commDocDate, commDocBy: commDocDate ? blStatus.commDocBy : '', commDocChk: commDocDate ? blStatus.commDocChk : false})}
              userId={blStatus.commDocBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Send ATME"
              disabled={isView}
              checked={!!blStatus.entryDocChk}
              onToggle={entryDocChk => onChange({
                entryDocChk,
                entryDocDate: entryDocChk ? now() : null,
                entryDocBy: entryDocChk ? user : '',
                })}
              dateTime={blStatus.entryDocDate}
              onDateTimeChange={entryDocDate => onChange({entryDocDate, entryDocBy: entryDocDate ? blStatus.entryDocBy : '', entryDocChk: entryDocDate ? blStatus.entryDocChk : false})}
              userId={blStatus.entryDocBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Confirm AMS Filing"
              disabled={isView}
              checked={!!blStatus.f3461Chk}
              onToggle={f3461Chk => onChange({
                f3461Chk,
                f3461Date: f3461Chk ? now() : null,
                f3461By: f3461Chk ? user : '',
                })}
              dateTime={blStatus.f3461Date}
              onDateTimeChange={f3461Date => onChange({f3461Date, f3461By: f3461Date ? blStatus.f3461By : '', f3461Chk: f3461Date ? blStatus.f3461Chk : false})}
              userId={blStatus.f3461By}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Receive 7501 Docs"
              disabled={isView}
              checked={!!blStatus.anPrtChk}
              onToggle={anPrtChk => onChange({
                anPrtChk,
                anPrtDate: anPrtChk ? now() : null,
                anPrtBy: anPrtChk ? user : '',
                })}
              dateTime={blStatus.anPrtDate}
              onDateTimeChange={anPrtDate => onChange({anPrtDate, anPrtBy: anPrtDate ? blStatus.anPrtBy : '', anPrtChk: anPrtDate ? blStatus.anPrtChk : false})}
              userId={blStatus.anPrtBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Receive 3461 Docs"
              disabled={isView}
              checked={!!blStatus.delSchedChk}
              onToggle={delSchedChk => onChange({
                delSchedChk,
                delSchedDate: delSchedChk ? now() : null,
                delSchedBy: delSchedChk ? user : '',
                })}
              dateTime={blStatus.delSchedDate}
              onDateTimeChange={delSchedDate => onChange({delSchedDate, delSchedBy: delSchedDate ? blStatus.delSchedBy : '', delSchedChk: delSchedDate ? blStatus.delSchedChk : false})}
              userId={blStatus.delSchedBy}
            />
          </InlineInputControlRowNoLabel>
        </div>

        <div style={{marginLeft: '30px', width: '325px'}}>
          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Confirm ETD"
              disabled={isView}
              checked={!!blStatus.delActChk}
              onToggle={delActChk => onChange({
                delActChk,
                delActDate: delActChk ? now() : null,
                delActBy: delActChk ? user : '',
                })}
              dateTime={blStatus.delActDate}
              onDateTimeChange={delActDate => onChange({delActDate, delActBy: delActDate ? blStatus.delActBy : '', delActChk: delActDate ? blStatus.delActChk : false})}
              userId={blStatus.delActBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Confirm ATA"
              disabled={isView}
              checked={!!blStatus.emptyRetChk}
              onToggle={emptyRetChk => onChange({
                emptyRetChk,
                emptyRetDate: emptyRetChk ? now() : null,
                emptyRetBy: emptyRetChk ? user : '',
                })}
              dateTime={blStatus.emptyRetDate}
              onDateTimeChange={emptyRetDate => onChange({emptyRetDate, emptyRetBy: emptyRetDate ? blStatus.emptyRetBy : '', emptyRetChk: emptyRetDate ? blStatus.emptyRetChk : false})}
              userId={blStatus.emptyRetBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Cargo Release"
              disabled={isView}
              checked={!!blStatus.paidDate}
              onToggle={isRls => onChange({
                //isRls,
                paidDate: isRls ? now() : null,
                rlsBy: isRls ? user : '',
                })}
              dateTime={blStatus.paidDate}
              onDateTimeChange={paidDate => onChange({paidDate, rlsBy: paidDate ? blStatus.rlsBy : '', /*isRls: paidDate ? blStatus.isRls : false*/ })}
              userId={blStatus.rlsBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Receive POD"
              disabled={isView}
              checked={!!blStatus.podChk}
              onToggle={podChk => onChange({
                podChk,
                podDate: podChk ? now() : null,
                podBy: podChk ? user : '',
                })}
              dateTime={blStatus.podDate}
              onDateTimeChange={podDate => onChange({podDate, podBy: podDate ? blStatus.podBy : '', podChk: podDate ? blStatus.podChk : false})}
              userId={blStatus.podBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Billing Packet Mailed"
              disabled={isView}
              checked={!!blStatus.billPacketChk}
              onToggle={billPacketChk => onChange({
                billPacketChk,
                billPacketDate: billPacketChk ? now() : null,
                billPacketBy: billPacketChk ? user : '',
                })}
              dateTime={blStatus.billPacketDate}
              onDateTimeChange={billPacketDate => onChange({billPacketDate, billPacketBy: billPacketDate ? blStatus.billPacketBy : '', billPacketChk: billPacketDate ? blStatus.billPacketChk : false})}
              userId={blStatus.billPacketBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Complete Billing"
              disabled={isView}
              checked={!!blStatus.billChk}
              onToggle={billChk => onChange({
                billChk,
                billDate: billChk ? now() : null,
                billBy: billChk ? user : '',
                })}
              dateTime={blStatus.billDate}
              onDateTimeChange={billDate => onChange({billDate, billBy: billDate ? blStatus.billBy : '', billChk: billDate ? blStatus.billChk : false})}
              userId={blStatus.billBy}
            />
          </InlineInputControlRowNoLabel>
        </div>
      </div>
    </div>
  );
}

export default React.memo(HawbMilestone);
